import { useState, useCallback, useEffect } from 'react';
import { endpoints } from '../../../../utils/URL';
import axios from 'axios';
import { addToast } from '../../../../utils/toastNotifications';
import { ILoanApplicationDetail } from '../../../../interface/LoanInterface';
import { useParams } from 'react-router-dom';
import { Tab, Tabs } from 'react-bootstrap';
import LoanInfo from './LoanInfo';
import Repayments from './Repayments';

const LoanDetails = () => {
  const [data, setData] = useState<ILoanApplicationDetail | undefined>();
  const [key, setKey] = useState('Info');

  const { applicationId } = useParams() as any;

  const getLoanApplications = useCallback(async () => {
    console.log(applicationId);
    let url = `${endpoints.loans.mainUrl}/applications/${applicationId}`;

    try {
      const response = await axios.get(url);
      const loanData: ILoanApplicationDetail = response.data;

      setData(loanData);
    } catch (error) {
      addToast('Error fetching loans', 'error');
    } finally {
    }
  }, [applicationId]);

  useEffect(() => {
    getLoanApplications();
  }, [getLoanApplications]);

  return (
    <div>
      {data && (
        <div className='mt-5'>
          <Tabs
            fill
            id='controlled-tab-example'
            activeKey={key}
            onSelect={(k) => setKey(k as string)}
            className='patient-tab'
          >
            <Tab eventKey={'Info'} title='General Info'>
              <LoanInfo tabKey='Info' data={data} />
            </Tab>
            <Tab eventKey={'Repayments'} title='Repayment Info'>
              <Repayments tabKey='Repayments' data={data} />
            </Tab>
          </Tabs>
        </div>
      )}
    </div>
  );
};

export default LoanDetails;
